export const minimumZoomSetter = (
    distanceBetweenGeneratedPoints: number | undefined,
    setMinimumGridDisplayZoom: React.Dispatch<React.SetStateAction<number>>,
) => {
    if (distanceBetweenGeneratedPoints) {
        if (distanceBetweenGeneratedPoints >= 1000) {
            setMinimumGridDisplayZoom(10);
        } else if (distanceBetweenGeneratedPoints >= 500 && distanceBetweenGeneratedPoints < 1000) {
            setMinimumGridDisplayZoom(12);
        } else if (distanceBetweenGeneratedPoints > 100 && distanceBetweenGeneratedPoints < 500) {
            setMinimumGridDisplayZoom(13);
        } else if (distanceBetweenGeneratedPoints <= 100 && distanceBetweenGeneratedPoints >= 70) {
            setMinimumGridDisplayZoom(15);
        } else if (distanceBetweenGeneratedPoints < 70) {
            setMinimumGridDisplayZoom(16);
        }
    }
};
